import React, { useState, useEffect } from 'react';
import './Contact.css';

// EmailJS configuration - You need to sign up at https://www.emailjs.com
// Replace these with your actual EmailJS credentials
const EMAILJS_SERVICE_ID = 'service_omw09v8';
const EMAILJS_TEMPLATE_ID = 'template_v7fxr1b';
const EMAILJS_PUBLIC_KEY = '1j7zXID8jh_lIjt1x';

const Contact = ({ language = 'en' }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    query: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [emailJsLoaded, setEmailJsLoaded] = useState(false);

  // Translations
  const translations = {
    en: {
      title: 'CONTACT',
      subtitle: 'Get in Touch',
      description: 'At PA Global Collab, we are dedicated to providing our customers with the finest stone products available. Whether you\'re looking for natural stone or prefabricated stone, we have the perfect product for your project. Contact us today to learn more about our products and how we can help you achieve your stone design goals.',
      contactInfo: 'Contact Information',
      address: 'D-3 Haridas Ji ki Magri',
      addressLine2: 'Udaipur, Rajasthan, India',
      queryForm: 'Query Form',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      phonePlaceholder: '+91 9876543210',
      email: 'Email',
      query: 'Your Query',
      submit: 'Submit',
      submitting: 'Sending...',
      successMessage: 'Thank you! We\'ll get back to you soon.',
      errorMessage: 'Something went wrong. Please try again.',
      required: 'Required',
      wechat: 'WeChat'
    },
    zh: {
      title: '联系我们',
      subtitle: '取得联系',
      description: '在 PA Global Collab，我们致力于为客户提供最优质的石材产品。无论您是在寻找天然石材还是预制石材，我们都有适合您项目的完美产品。今天就联系我们，了解更多关于我们产品的信息。',
      contactInfo: '联系信息',
      address: 'D-3 Haridas Ji ki Magri',
      addressLine2: '印度拉贾斯坦邦乌代浦尔',
      queryForm: '查询表格',
      firstName: '名',
      lastName: '姓',
      phone: '电话',
      phonePlaceholder: '+86 13812345678',
      email: '电子邮件',
      query: '您的查询',
      submit: '提交',
      submitting: '发送中...',
      successMessage: '谢谢！我们会尽快回复您。',
      errorMessage: '出了点问题。请重试。',
      required: '必填',
      wechat: '微信'
    },
    it: {
      title: 'CONTATTO',
      subtitle: 'Mettiti in Contatto',
      description: 'In PA Global Collab, siamo dedicati a fornire ai nostri clienti i migliori prodotti in pietra disponibili. Che tu stia cercando pietra naturale o pietra prefabbricata, abbiamo il prodotto perfetto per il tuo progetto.',
      contactInfo: 'Informazioni di Contatto',
      address: 'D-3 Haridas Ji ki Magri',
      addressLine2: 'Udaipur, Rajasthan, India',
      queryForm: 'Modulo di Richiesta',
      firstName: 'Nome',
      lastName: 'Cognome',
      phone: 'Telefono',
      phonePlaceholder: '+39 3123456789',
      email: 'Email',
      query: 'La Tua Richiesta',
      submit: 'Invia',
      submitting: 'Invio...',
      successMessage: 'Grazie! Ti risponderemo presto.',
      errorMessage: 'Qualcosa è andato storto. Riprova.',
      required: 'Richiesto',
      wechat: 'WeChat'
    }
  };

  const t = translations[language] || translations.en;

  useEffect(() => {
    // Load EmailJS script dynamically
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js';
    script.async = true;
    script.onload = () => {
      if (window.emailjs) {
        window.emailjs.init(EMAILJS_PUBLIC_KEY);
        setEmailJsLoaded(true);
      }
    };
    document.body.appendChild(script);

    // Mouse move handler
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      setMousePosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);

    // Intersection observer for animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      observer.disconnect();
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const sendEmailViaEmailJS = async () => {
    if (!window.emailjs || !emailJsLoaded) {
      throw new Error('EmailJS not loaded');
    }

    // Format the email content
    const templateParams = {
      from_name: `${formData.firstName} ${formData.lastName}`,
      from_email: formData.email,
      phone_number: formData.phone,
      message: formData.query,
      to_email: 'cpwork9799@gmail.com, punit@collabpa.com, abhishekdhabhai@gmail.com',
      reply_to: formData.email
    };

    // Send email using EmailJS
    const response = await window.emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    return response;
  };

  const sendEmailViaMailto = () => {
    // Recipients
    const recipients = ['cpwork9799@gmail.com', 'punit@collabpa.com', 'abhishekdhabhai@gmail.com'].join(',');
    
    // Create email subject and body
    const subject = `New Query from ${formData.firstName} ${formData.lastName}`;
    const body = `
New Query Submission
====================

Name: ${formData.firstName} ${formData.lastName}
Phone: ${formData.phone}
Email: ${formData.email}

Query:
${formData.query}

====================
This email was sent from the PA Global Collab contact form.
    `;
    
    // Create mailto link
    const mailtoLink = `mailto:${recipients}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open email client
    window.location.href = mailtoLink;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Check if EmailJS is configured
      if (EMAILJS_SERVICE_ID !== 'YOUR_SERVICE_ID' && emailJsLoaded) {
        // Try to send via EmailJS
        await sendEmailViaEmailJS();
        
        setSubmitStatus('success');
        setFormData({
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          query: ''
        });
      } else {
        // Fallback to mailto
        sendEmailViaMailto();
        
        // Show success message after a delay (since mailto doesn't provide feedback)
        setTimeout(() => {
          setSubmitStatus('success');
          setFormData({
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            query: ''
          });
        }, 1000);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      // Fallback to mailto if EmailJS fails
      sendEmailViaMailto();
      setSubmitStatus('success');
    } finally {
      setIsSubmitting(false);
      // Clear status message after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  const handleEmailClick = (e) => {
    e.preventDefault();
    window.location.href = 'mailto:info@collabpa.com';
  };

  return (
    <div className="contact-container">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-background">
          <div className="parallax-layer layer-1" />
        </div>
        <div className="hero-content">
          <h1 className="hero-title">{t.title}</h1>
          <p className="hero-subtitle">{t.subtitle}</p>
          
          {/* Animated Communication Illustration */}
          <div className="communication-animation hero-animation">
            <div className="chat-bubble bubble-1">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="phone-icon">
              <div className="phone-ring ring-1"></div>
              <div className="phone-ring ring-2"></div>
              📞
            </div>
            <div className="chat-bubble bubble-2">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="contact-content">
        <div className="content-wrapper">
          {/* Left Side - Contact Info */}
          <div className="contact-info-section animate-on-scroll">
            <div className="info-description">
              <p>{t.description}</p>
            </div>

            <div className="info-card">
              <h2>{t.contactInfo}</h2>
              
              <div className="info-item">
                <div className="info-icon">📍</div>
                <div className="info-text">
                  <p>{t.address}</p>
                  <p>{t.addressLine2}</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">📱</div>
                <div className="info-text">
                  <p>+91 73759 99555 (WhatsApp)</p>
                  <p>+1 2192351725 ({t.wechat})</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">✉️</div>
                <div className="info-text">
                  <p>
                    <a 
                      href="mailto:info@collabpa.com" 
                      onClick={handleEmailClick}
                      style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}
                    >
                      info@collabpa.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Query Form */}
          <div className="form-section animate-on-scroll">
            <div className="form-card">
              <h2>{t.queryForm}</h2>
              
              <div className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>
                      {t.firstName} <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>
                      {t.lastName} <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      required
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>
                    {t.phone} <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                    placeholder={t.phonePlaceholder}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {t.email} <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label>
                    {t.query} <span className="required">*</span>
                  </label>
                  <textarea
                    name="query"
                    value={formData.query}
                    onChange={handleInputChange}
                    required
                    className="form-input form-textarea"
                    rows="5"
                    placeholder="Tell us about your query..."
                  />
                </div>

                <button 
                  onClick={handleSubmit}
                  className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
                  disabled={isSubmitting}
                >
                  <span>{isSubmitting ? t.submitting : t.submit}</span>
                  <svg className="submit-arrow" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                {submitStatus && (
                  <div className={`status-message ${submitStatus}`}>
                    {submitStatus === 'success' ? t.successMessage : t.errorMessage}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Floating Background Elements */}
      <div className="background-shapes">
        <div 
          className="shape shape-1"
          style={{ transform: `translate(${mousePosition.x * 20}px, ${mousePosition.y * 20}px)` }}
        />
        <div 
          className="shape shape-2"
          style={{ transform: `translate(${mousePosition.x * -15}px, ${mousePosition.y * -15}px)` }}
        />
      </div>
    </div>
  );
};

export default Contact;